import { render, staticRenderFns } from "./ContentAlignment.vue?vue&type=template&id=d6928cc2&"
import script from "./ContentAlignment.vue?vue&type=script&lang=js&"
export * from "./ContentAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports